// extracted by mini-css-extract-plugin
module.exports = {"loadMoreButton":"styles_loadMoreButton__2Zun7","ftrLoaderBox":"styles_ftrLoaderBox__3rRZp"};